export enum Role {
  ADMIN = "ADMIN",
  IMAGE_CAPTAIN = "IMAGE_CAPTAIN",
  VIDEO_CAPTAIN = "VIDEO_CAPTAIN",
  STREAMING_CAPTAIN = "STREAMING_CAPTAIN",
  IMAGE_QUALITY_CONTROLLER = "IMAGE_QUALITY_CONTROLLER",
  VIDEO_QUALITY_CONTROLLER = "VIDEO_QUALITY_CONTROLLER",
  STREAMING_QUALITY_CONTROLLER = "STREAMING_QUALITY_CONTROLLER",
}
